let SERVER;
let API;
let CHURCH_API;
let SESSION_API;
let STUDENTS_API;
let BUTTONSTATE_API;
let EVENTS_API;
let LOGIN_API;
let HOMECAT_API;
let PARENTS_API;
let UPDATES_API;
let DOCVIEWER;
let LOG_API;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
  API = 'http://localhost/api/'; // BASE URL
else API = 'https://cats.olps.sg/api/'; // BASE URL

CHURCH_API = API + 'churches'; // get singapore churches
SESSION_API = API + 'sessions'; // get session slots
STUDENTS_API = API + 'students'; // get all students
BUTTONSTATE_API = API + 'getbuttonstate'; // get document upload status
EVENTS_API = API + 'events'; // get events list
LOGIN_API = API + 'login'; // admin login
HOMECAT_API = API + 'homecat'; // Home cats admin
PARENTS_API = API + 'parents'; // Parents admin
UPDATES_API = API + 'latestupdates';
DOCVIEWER = API + 'docviewer'; // Open and view uploaded docs
LOG_API = API + 'log';

const apis = {
  SERVER,
  API,
  CHURCH_API,
  STUDENTS_API,
  SESSION_API,
  BUTTONSTATE_API,
  EVENTS_API,
  LOGIN_API,
  HOMECAT_API,
  PARENTS_API,
  UPDATES_API,
  DOCVIEWER,
  LOG_API,
};

export default apis;
